import React from "react";
import { ComplianceCenterProvider } from "../context/ComplianceCenterContext";

type Props = {
  children: React.ReactNode;
};

/**
 * Phase 1 shell wrapper. Keeps current page visuals unchanged and
 * only introduces orchestration boundaries for the future unified center.
 */
export const ComplianceCenterShell: React.FC<Props> = ({ children }) => {
  return (
    <ComplianceCenterProvider>
      <div data-testid="compliance-center-shell">{children}</div>
    </ComplianceCenterProvider>
  );
};

